const fvSlider = () => {
    const slider = document.querySelector('.p-front__fv__slider');
    if (!slider) return;

    const slides = slider.querySelectorAll('.p-front__fv__slide');
    if (slides.length === 0) return;

    let currentIndex = 0;

    // 最初にすべてのスライドを非表示にし、最初のスライドだけを表示
    slides.forEach((slide, index) => {
        if (index === 0) {
            slide.classList.add('active');
        } else {
            slide.classList.remove('active');
        }
    });

    const showNextSlide = () => {
        slides[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('active');
    };

    setInterval(showNextSlide, 5000);
};

document.addEventListener('DOMContentLoaded', fvSlider);
